import React from 'react'

export const RawCreditAppContext = React.createContext()
